<template>
  <v-dialog
    v-model="localDialog"
    :max-width="modalLayout.XL"
    v-bind="modalP2FormViewport"
    @close="close"
    @keydown.esc="close"
  >
    <v-form ref="panelProductForm" v-model="valid" @submit.prevent="save">
      <v-card>
        <CrudFormDialogHeader
          :kicker="$t('panelProductCrud.title')"
          :title="formTitle"
          show-close
          @close="close"
        />
        <v-card-text style="padding-top: 20px; font-size: 14px">
          <v-row>
            <!-- 왼쪽 컬럼 -->
            <v-col cols="6">
              <v-card flat class="ml-5">
                <v-row align="baseline">
                  <v-col cols="4" class="custom-padding required">
                    <label>{{ $t('panelProductCrud.form.modelName') }}</label>
                  </v-col>
                  <v-col cols="8" class="custom-padding">
                    <v-text-field
                      v-model="editedItem.modelName"
                      :rules="[requiredRule]"
                      required
                      dense
                      hide-details="auto"
                    />
                  </v-col>
                </v-row>
                <v-row align="baseline">
                  <v-col cols="4" class="custom-padding required">
                    <label>{{ $t('panelProductCrud.form.maker') }}</label>
                  </v-col>
                  <v-col cols="8" class="custom-padding">
                    <v-text-field
                      v-model="editedItem.maker"
                      hide-details="auto"
                      dense
                      :rules="[requiredRule]"
                    />
                  </v-col>
                </v-row>
                <v-row align="baseline">
                  <v-col cols="4" class="custom-padding">
                    <label>{{ $t('panelProductCrud.form.maxPower') }}</label>
                  </v-col>
                  <v-col cols="8" class="custom-padding">
                    <v-text-field
                      v-model.number="editedItem.maxPowerOutput"
                      hide-details="auto"
                      dense
                      suffix="W"
                      :rules="[numericRule]"
                    />
                  </v-col>
                </v-row>
                <v-row align="baseline">
                  <v-col cols="4" class="custom-padding required">
                    <label>{{ $t('panelProductCrud.form.width') }}</label>
                  </v-col>
                  <v-col cols="8" class="custom-padding">
                    <v-text-field
                      v-model.number="editedItem.width"
                      hide-details="auto"
                      dense
                      suffix="mm"
                      :rules="[requiredRule, numericRule]"
                    />
                  </v-col>
                </v-row>
                <v-row align="baseline">
                  <v-col cols="4" class="custom-padding required">
                    <label>{{ $t('panelProductCrud.form.height') }}</label>
                  </v-col>
                  <v-col cols="8" class="custom-padding">
                    <v-text-field
                      v-model.number="editedItem.height"
                      hide-details="auto"
                      dense
                      suffix="mm"
                      :rules="[requiredRule, numericRule]"
                    />
                  </v-col>
                </v-row>
                <v-row align="baseline">
                  <v-col cols="4" class="custom-padding">
                    <label>{{ $t('panelProductCrud.form.thickness') }}</label>
                  </v-col>
                  <v-col cols="8" class="custom-padding">
                    <v-text-field
                      v-model.number="editedItem.thickness"
                      hide-details="auto"
                      dense
                      suffix="mm"
                      :rules="[numericRule]"
                    />
                  </v-col>
                </v-row>
                <v-row align="baseline">
                  <v-col cols="4" class="custom-padding">
                    <label>{{ $t('panelProductCrud.form.maxVoltage') }}</label>
                  </v-col>
                  <v-col cols="8" class="custom-padding">
                    <v-text-field
                      v-model.number="editedItem.maxVoltage"
                      hide-details="auto"
                      dense
                      suffix="V"
                      :rules="[numericRule]"
                    />
                  </v-col>
                </v-row>
                <v-row align="baseline">
                  <v-col cols="4" class="custom-padding">
                    <label>{{ $t('panelProductCrud.form.maxCurrent') }}</label>
                  </v-col>
                  <v-col cols="8" class="custom-padding">
                    <v-text-field
                      v-model.number="editedItem.maxCurrent"
                      hide-details="auto"
                      dense
                      suffix="A"
                      :rules="[numericRule]"
                    />
                  </v-col>
                </v-row>
                <v-row align="baseline">
                  <v-col cols="4" class="custom-padding">
                    <label>{{ $t('panelProductCrud.form.openCircuitVoltage') }}</label>
                  </v-col>
                  <v-col cols="8" class="custom-padding">
                    <v-text-field
                      v-model.number="editedItem.openCircuitVoltage"
                      hide-details="auto"
                      dense
                      suffix="V"
                      :rules="[numericRule]"
                    />
                  </v-col>
                </v-row>
                <v-row align="baseline">
                  <v-col cols="4" class="custom-padding">
                    <label>{{ $t('panelProductCrud.form.shortCircuitCurrent') }}</label>
                  </v-col>
                  <v-col cols="8" class="custom-padding">
                    <v-text-field
                      v-model.number="editedItem.shortCircuitCurrent"
                      hide-details="auto"
                      dense
                      step="0.01"
                      suffix="A"
                      :rules="[numericRule]"
                    />
                  </v-col>
                </v-row>
                <v-row align="baseline">
                  <v-col cols="4" class="custom-padding">
                    <label>{{ $t('panelProductCrud.form.weight') }}</label>
                  </v-col>
                  <v-col cols="8" class="custom-padding">
                    <v-text-field
                      v-model.number="editedItem.weight"
                      hide-details="auto"
                      dense
                      suffix="kg"
                      :rules="[numericRule]"
                    />
                  </v-col>
                </v-row>
                <v-row align="baseline">
                  <v-col cols="4" class="custom-padding">
                    <label>{{ $t('panelProductCrud.form.warrantyPeriod') }}</label>
                  </v-col>
                  <v-col cols="8" class="custom-padding">
                    <v-text-field
                      v-model.number="editedItem.warrantyPeriodYears"
                      hide-details="auto"
                      dense
                      step="1"
                      :suffix="$t('panelProductCrud.form.warrantySuffix')"
                      :rules="[numericRule]"
                    />
                  </v-col>
                </v-row>
              </v-card>
            </v-col>

            <!-- 오른쪽 컬럼 -->
            <v-col cols="6">
              <v-card flat class="ml-5">
                <v-row align="baseline">
                  <v-col cols="4" class="custom-padding">
                    <label>{{ $t('panelProductCrud.form.numberOfCells') }}</label>
                  </v-col>
                  <v-col cols="8" class="custom-padding">
                    <v-text-field
                      v-model.number="editedItem.numberOfCells"
                      hide-details="auto"
                      dense
                      :rules="[numericRule]"
                    />
                  </v-col>
                </v-row>
                <v-row align="baseline">
                  <v-col cols="4" class="custom-padding">
                    <label>{{ $t('panelProductCrud.form.cellEfficiency') }}</label>
                  </v-col>
                  <v-col cols="8" class="custom-padding">
                    <v-text-field
                      v-model.number="editedItem.cellEfficiency"
                      hide-details="auto"
                      dense
                      suffix="%"
                      :rules="[numericRule]"
                    />
                  </v-col>
                </v-row>
                <v-row align="baseline">
                  <v-col cols="4" class="custom-padding">
                    <label>{{ $t('panelProductCrud.form.operatingTempMin') }}</label>
                  </v-col>
                  <v-col cols="8" class="custom-padding">
                    <v-text-field
                      v-model.number="editedItem.operatingTempMin"
                      hide-details="auto"
                      dense
                      suffix="°C"
                      :rules="[numericRule]"
                    />
                  </v-col>
                </v-row>
                <v-row align="baseline">
                  <v-col cols="4" class="custom-padding">
                    <label>{{ $t('panelProductCrud.form.operatingTempMax') }}</label>
                  </v-col>
                  <v-col cols="8" class="custom-padding">
                    <v-text-field
                      v-model.number="editedItem.operatingTempMax"
                      hide-details="auto"
                      dense
                      suffix="°C"
                      :rules="[numericRule]"
                    />
                  </v-col>
                </v-row>
                <v-row align="baseline">
                  <v-col cols="4" class="custom-padding">
                    <label>{{ $t('panelProductCrud.form.ipRating') }}</label>
                  </v-col>
                  <v-col cols="8" class="custom-padding">
                    <v-text-field
                      v-model="editedItem.ipRating"
                      hide-details="auto"
                      dense
                      :placeholder="$t('panelProductCrud.form.ipPlaceholder')"
                    />
                  </v-col>
                </v-row>
                <v-row align="baseline">
                  <v-col cols="4" class="custom-padding">
                    <label>{{ $t('panelProductCrud.form.cellType') }}</label>
                  </v-col>
                  <v-col cols="8" class="custom-padding">
                    <v-select
                      v-model="editedItem.panelProductCellType"
                      :items="cellTypeOptions"
                      item-text="label"
                      item-value="value"
                      hide-details="auto"
                      dense
                    />
                  </v-col>
                </v-row>
                <v-row align="baseline">
                  <v-col cols="2" class="custom-padding">
                    <label>{{ $t('panelProductCrud.form.panelImage') }}</label>
                  </v-col>
                  <v-col cols="10" class="custom-padding">
                    <ImageUploader
                      :file="productImage"
                      :server-image-path="editedItem.productImagePath"
                      :label="$t('panelProductCrud.form.imageSelectLabel')"
                      :max-size="10"
                      :image-size="300"
                      @update="handlePanelImageUpdate"
                      @remove="handlePanelImageRemove"
                      @error="handlePanelImageError"
                    />
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>

          <!-- 이미지 업로더는 전체 너비 사용 -->
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn outlined class="solvit-crud-outline-btn" @click="close">
            {{ $t('common.cancel') }}
          </v-btn>
          <v-btn outlined class="solvit-crud-outline-btn solvit-crud-outline-btn--primary" type="submit">
            {{ $t('common.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import Api from '@/apis/Api';
import { DEFAULT_PANEL_PRODUCT } from '@/constants/panelProduct';
import { createCellTypeOptions, validatePanelProduct } from '@/utils/panelProductUtils';
import ImageUploader from '../common/ImageUploader.vue';
import CrudFormDialogHeader from '@/components/common/CrudFormDialogHeader.vue';
import { MODAL_MAX_WIDTH, MODAL_P2_FORM_VIEWPORT } from '@/constants/modalLayout';

export default {
  name: 'PanelProductEditDialog',
  components: {
    ImageUploader,
    CrudFormDialogHeader
  },
  props: {
    dialog: {
      type: Boolean,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    cellTypes: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    modalLayout: MODAL_MAX_WIDTH,
    modalP2FormViewport: MODAL_P2_FORM_VIEWPORT,
    valid: true,
    editedItem: { ...DEFAULT_PANEL_PRODUCT },
    defaultItem: { ...DEFAULT_PANEL_PRODUCT },
    productImage: null
  }),
  computed: {
    localDialog: {
      get() {
        return this.dialog;
      },
      set(value) {
        this.$emit('update:dialog', value);
      }
    },
    formTitle() {
      return this.item.id
        ? this.$t('panelProductCrud.form.editTitle')
        : this.$t('panelProductCrud.form.addTitle');
    },
    requiredRule() {
      return (v) => !!v || this.$t('common.required');
    },
    numericRule() {
      return (v) => {
        if (v === '' || v === null || v === undefined) return true;
        const n = Number(v);
        return !Number.isNaN(n) || this.$t('common.numericOnly');
      };
    },
    cellTypeOptions() {
      return createCellTypeOptions(this.cellTypes);
    }
  },
  watch: {
    dialog(val) {
      if (val) {
        this.initialize();
      }
    },
    item: {
      immediate: true,
      handler(newVal) {
        this.editedItem = Object.assign({}, newVal);
        console.log('this.editedItem:', newVal);
      }
    }
  },
  methods: {
    initialize() {
      console.log('this.cellTypes:', this.cellTypes);
      this.editedItem = Object.assign({}, this.item);
    },
    handlePanelImageUpdate(file) {
      this.productImage = file;
    },
    handlePanelImageRemove() {
      this.productImage = null;
      this.editedItem.productImagePath = null;
    },
    handlePanelImageError(error) {
      this.$emit('error', error);
    },
    close() {
      this.$emit('close');
      this.$nextTick(() => {
        if (this.$refs.panelProductForm) {
          this.$refs.panelProductForm.resetValidation();
        }
        this.editedItem = { ...DEFAULT_PANEL_PRODUCT };
        this.productImage = null;
      });
    },
    async save() {
      if (!this.$refs.panelProductForm.validate()) return;

      // 추가 유효성 검사
      const validation = validatePanelProduct(this.editedItem);
      if (!validation.isValid) {
        alert(validation.errors.map((key) => this.$t(key)).join('\n'));
        return;
      }

      try {
        const formData = new FormData();

        // 각 필드를 개별적으로 추가
        formData.append('modelName', this.editedItem.modelName);
        formData.append('maker', this.editedItem.maker);

        formData.append('maxPowerOutput', this.editedItem.maxPowerOutput || '');
        formData.append('width', this.editedItem.width || '');
        formData.append('height', this.editedItem.height || '');
        formData.append('panelProductCellType', this.editedItem.panelProductCellType || '');

        // 추가된 필드들
        formData.append('maxVoltage', this.editedItem.maxVoltage || '');
        formData.append('maxCurrent', this.editedItem.maxCurrent || '');
        formData.append('openCircuitVoltage', this.editedItem.openCircuitVoltage || '');
        formData.append('shortCircuitCurrent', this.editedItem.shortCircuitCurrent || '');
        formData.append('weight', this.editedItem.weight || '');
        formData.append('thickness', this.editedItem.thickness || '');
        formData.append('warrantyPeriodYears', this.editedItem.warrantyPeriodYears || '');

        // 새로 추가된 필드들
        formData.append('numberOfCells', this.editedItem.numberOfCells || '');
        formData.append('cellEfficiency', this.editedItem.cellEfficiency || '');
        formData.append('operatingTempMin', this.editedItem.operatingTempMin || '');
        formData.append('operatingTempMax', this.editedItem.operatingTempMax || '');
        formData.append('ipRating', this.editedItem.ipRating || '');

        // ID가 있으면 추가 (수정 시)
        if (this.editedItem.id) {
          formData.append('id', this.editedItem.id);
        }

        // 이미지 파일 추가
        if (this.productImage) {
          formData.append('productImage', this.productImage);
        }

        if (this.editedItem.id) {
          await Api.update(`/panelproduct/${this.editedItem.id}`, formData, true);
        } else {
          await Api.create('/panelproduct', formData);
        }
        this.$emit('success');
        this.close();
      } catch (error) {
        console.error('Error saving panel product:', error);
        alert(this.$t('panelProductCrud.form.saveError'));
      }
    }
  }
};
</script>

<style scoped>
.v-dialog__content {
  max-height: 100%;
}
.v-dialog:not(.v-dialog--fullscreen) {
  max-height: 100%;
}
.custom-padding {
  padding: 8px 12px !important;
}

.required::after {
  content: "*";
  color: red;
  margin-left: 4px;
}
</style>
